module.exports = __webpack_public_path__ + "img/sn-logo-flipped.d4ced59.png";